import { patchRequest } from '@/core';
import { savedOrderSearches } from '@/requests';

export default async function updateSingleSavedOrderSearchRequest(id, patch) {
	let url = savedOrderSearches.getByIdPath(id);
	let response = await patchRequest(url, {}, patch);
	return response;
}
